export const locale = {
  lang: 'pt',
  data: {
    'LANDINFOCUS': {
      'ENCUESTAS':{
        'TITULO':'Este é um processo de Área de Foco',
        'NO-ENCU':'Você não tem atualmente um processo de pesquisa designado',
        'ENC-AUTO':'Pesquisa autorizada',
        'ENC-CORRECI':'A pesquisa foi enviada para correção',
        'MODAL_NO_COLAB_EMPRE':'Você ainda não carregou sua base de colaboradores, tem certeza de continuar?',
      },
      'STATUS-ENCUESTA':{
        '1': 'Em processo',
        '2':' Avaliar',
        '3':' Autorizado',
        '5': 'Correto',

      },
      'LISTA': {
        'TAB': 'Lista de participantes',
        'BUSCAR': {
          'INFO': 'Você pode pesquisar um ou mais participantes da lista digitando o nome abaixo',
          'PLACEHOLDER': 'Encontre um participante'
        },
        'AGREGAR': {
          'BOTON': 'Adicionar um participante'
        },
        'TABLA': {
          'COLUMNAS': {
            'NOMBRE': 'Nome completo',
            'EMAIL': 'O email',
            'ACCIONES': 'Ações disponíveis'
          }
        },
        'TOOLTIPS': {
          'AGREGAR': 'Adicione um participante à lista',
          'EDITAR': 'Edite os dados deste participante'
        }
      },
      'MODALES':{
        'CREARENC': 'Digite o nome da pesquisa',
        'CORRECTO': 'Foi adicionado corretamente',
        'DELETE': 'Você realmente quer eliminar',
        'COMDELETE': 'Corretamente removido',
        'RSPSI': 'SIM',
        'RSPNO': 'NÃO',
        'RSPOK': 'OK',
        'RSPACEPTAR': 'Aceitar',
        'CARGANDOLISTA': 'Recuperando a lista de participantes, por favor aguarde um momento'

      },

      'WIZARD':{
        'CARGANDOF': 'Carregamento de produtos adquiridos',
        'SINPRODS': 'Você não adquiriu este produto',
        'CREARENC': 'Criar pesquisa',
        'DONE': 'Ano de aplicação',
        'TITULO': 'BEMVINDO À ÁREA DE FOCO',
        'TFOCUS': 'SURVEYS TO FOCUS AREA ',
        'DELETE': 'Delete',
        'EDIT': 'Editar',
        'VERIPRE':'Verificar perguntas',
        'AVANCE': 'Avançar',
        'TITUVERI': 'Verificação de perguntas',
        'TITUTABTEM': 'Perguntas sobre modelos',
        'TITUTABADI': 'Perguntas personalizado',
        'TITUTAUTORIZADA': 'Pesquisa Autorizada',
        'TITUTNOAUTORIZADA': 'Pesquisa de Desautorização',
        'TITUTAUTORIZAR':'Autorizar Pesquisa',
        'TITUTCORREGIR': 'Pesquisa Correta',
      },
      'TABLACAMPOS':{
        'NAME': 'Nome da pesquisa',
        'FECHAI': 'Data de início',
        'FECHAF': 'Data prevista',
        'AVANCE': 'Avançar',
        'ESTADO': 'Status',
        'ACCION': 'Ações',
      },
      'COLABORADORES':{
        'CARGACOLAB':'Upload Certified Collaborators'
      },
      'GRUPOS':{
        'NOMBRE_OK': "Se agrego correctamente el nombre",
        'DESCRIPCION_OK': "Se agrego correctamente la descripcion",
      },
      'ADMIN-PREG':{
        'TITULO-ABIE':'Open questions',
        'PREGUN':'Questions',
        'PREGUNSUB':'Question',
        'DESCRIP-PREGUN':'Click here to display the question',
        'TITULO-UNAOPC':'One-choice questions',
        'TITULO-MULOPC':'Multiple choice questions',
        'OPC':'Options',
        'OPCSUB':'Option',
        'NO-ADICI':'A pesquisa não tem perguntas adicionais',
      },
      'IDIOM-NATIVO':{
        'pt':'Portugues',
        'es':'Español',
        'en':'English',
      },
      'STEP_COLAB':{
        'STEP_1':{
          'TITULO_STEP_ELEGIR_COLAB':'Tipo de seleção de colaboradores',
          'INST_1':'Selecione uma das seguintes opções',
          'NUEVA_BASE_COLA':'Upload de nova base de colaboradores',
          'BASE_COLAB_EXIS':'Use a base de contribuinte principal',
          'BTN_SIGUENTE':'Próximo',

        },
        'STEP_2':{
          'TITULO_STEP_SUBIR_COLAB':'Seleção de colaboradores',
          'MAT_TITLE_DEMO_SELE':'Dados demográficos selecionados',
          'ALERT_NOT_DEMO_SELE':'Você ainda não selecionou os filtros',
          'ALERT_NOT_SELE_COLAB':'Nenhum colaborador adicionado',
          'AGREGAR_FILTRO':'Adicionar filtro',
          'TH_NOMBRE':'Nome do contribuinte',
          'TH_ACCION':'Ações',
          'INTS_SEL_1_O_MAS_COLAB':'*Nota: selecione um ou mais colaboradores',
          'SIN_RESULTADOS':'A seleção de filtro atual não retornou nenhum resultado, tente alterar os filtros e tente novamente',
          'BTN_REGRESAR':'Retornar',
          'BTN_AGRE_COLAB':'Adicionar colaboradores',
          'BTN_GUAR_COLAB':'Salve os colaboradores',
          'BTN_BORR_COLAB':'Eliminar os colaboradores',
          'BTN_ACEPTAR':'Aceitar',
          'BTN_BUSCAR':'Busca',
          'TITULO_MODAL_DEMOGRA':'Lista de dados demográficos',
          'MAT_TITLE_EXPA_RESULT':'Resultados da pesquisa do contribuinte:',
          'MAT_TITLE_EXPA_AGREG':'Colaboradores agregados:',
          'MAT_TITLE_EXPA_DESCRIP':'Ver colaboradores',
          'MODALES':{
            'MODAL_CARGAN_FILTROS':'Filtros de carregamento',
            'MODAL_BUSCA_COLAB':'Busca de colaboradores filtrados',
            'MODAL_AGRE_COLAB':'Acréscimo de colaboradores',
            'MODAL_DELET_COLAB':'Eliminar informações sobre o colaborador',
            'MODAL_SUCCES_AGRE_COLAB':'Os colaboradores foram acrescentados com sucesso',
            'MODAL_GUAR_COLAB':'Salvando os colaboradores',
            'MODAL_CONFIR_BORRAR_COLAB':'¿Você tem certeza de excluir o colaborador?',
            'MODAL_CONFIR_BORRAR_COLABRES':'¿Você tem certeza de excluir os colaboradores?',
            'MODAL_CONFIR_GUAR_COLAB_BACK':'¿ Você tem certeza de salvar os colaboradores adicionados?',
            'MODAL_SUCCES_GUAR_COLAB':'Os colaboradores foram salvos com sucesso',
            'MODAL_SUCCES_BORRA_COLAB':'O contribuinte foi excluído com sucesso',
            'MODAL_SUCCES_BORRA_COLABRES':'Os colaboradores foram eliminados com sucesso',
            'MODAL_WARNN_NO_SELECT_COLAB':'Você ainda não selecionou nenhum contribuinte',
            'BTN_SI':'Sim',
            'BTN_NO':'Não',
            'BTN_OK':'Ok',
          },
          'FORMULARIO':{
            'fullName': 'Nome do colaborador',
            'ownKey': 'Número / senha do colaborador',
            'age': 'Ano de nascimento',
            'surveyKey': 'Senha para entrar na pesquisa',
            'email': 'Correio eletrônico',
            'bossName': 'Nome do chefe direto',
            'bossKey': 'Número / código do chefe direto',
            'country': 'País',
            'location': 'Localização',
            'geo_1': 'Nível geográfico 1',
            'geo_2': 'Nível geográfico 2',
            'geo_3': 'Nível geográfico 3',
            'geo_4': 'Nível geográfico 4',
            'geo_5': 'Nível geográfico 5',
            'geo_6': 'Nível geográfico 6',
            'geo_7': 'Nível geográfico 7',
            'geo_8': 'Nível geográfico 8',
            'geo_9': 'Nível geográfico 9',
            'geo_10': 'Nível geográfico 10',
            'structure_1': 'Nível estrutural 1',
            'structure_2': 'Nível estrutural 2',
            'structure_3': 'Nível estrutural 3',
            'structure_4': 'Nível estrutural 4',
            'structure_5': 'Nível estrutural 5',
            'structure_6': 'Nível estrutural 6',
            'structure_7': 'Nível estrutural 7',
            'structure_8': 'Nível estrutural 8',
            'structure_9': 'Nível estrutural 9',
            'structure_10': 'Nível estrutural 10',
            'area': 'Área',
            'bUnit': 'Unidade de negócio',
            'enterDate': 'data de admissão',
            'antiquity': 'Antiguidade',
            'antiquityUS': 'Antiguidade US',
            'generation': 'Geração',
            'generationUS': 'Geração dos EUA',
            'ageUS': 'Era',
            'charge': 'Cargo ou função na empresa',
            'homologado': 'Cargo ou função oficial',
            'homologadoUS': 'Cargo ou função aprovada nos EUA',
            'gender': 'Gênero',
            'genderType': 'Tipo de gênero',
            'typeofwork': 'Esquema de compensação',
            'workCondition': 'Condição de trabalho',
            'academico': 'Grau acadêmico',
            'contratacion': 'Tipo de contrato',
            'situacionUS': 'Status de emprego nos EUA',
            'personal': 'Tipo de pessoal',
            'jornada': 'Tipo de jornada de trabalho',
            'rotacion': 'Mudança de rotação',
            'phone': 'Telefone',
            'extension': 'Extensão',
            'cellphone': 'Número de celular',
            'native': 'Língua materna',
            'answer': 'Responda',
            'other_1': 'Outros 1',
            'other_2': 'Outros 2',
            'other_3': 'Outros 3',
            'other_4': 'Outros 4',
            'other_5': 'Outros 5',
            'other_6': 'Outros 6',
            'other_7': 'Outros 7',
            'other_8': 'Outros 8',
            'other_9': 'Outros 9',
            'other_10': 'Outros 10',
          },
        },
    }

    }
  }
};
